const Backbone = require('backbone');
const $ = require('jquery');

module.exports = Backbone.View.extend({
	el: '#category-expert',

	events: {
		'click .js-expert-call-us': '_handleCallUsReveal'
	},

	_handleCallUsReveal: function() {
		const $callUsText = $('.js-expert-call-us');
		const $callUsNumber = $('.js-expert-phone-number');

		if ($callUsText && $callUsText.length && $callUsNumber && $callUsNumber.length) {
			$callUsText.toggleClass('hide');
			$callUsNumber.toggleClass('hide');
		}
	}
});
